import React from 'react'

const UpArrowIcon: React.FC = (props) => (
	<svg {...props} focusable='false' viewBox='0 0 24 24' aria-hidden='true'>
		<path d='M7.41 15.41L12 10.83l4.59 4.58L18 14l-6-6-6 6z'></path>
	</svg>
)

export default UpArrowIcon
